// src/redux/reducers/reviewsReducer.js

import {
    FETCH_REVIEWS_REQUEST,
    FETCH_REVIEWS_SUCCESS,
    FETCH_REVIEWS_FAILURE,
    UPDATE_REVIEWS_REQUEST,
    REVIEWS_EXPORT_REQUEST,
    DELETE_ALL_REVIEW_REQUEST,
    DELETE_REVIEW_BY_PRODUCT_REQUEST,
    UPDATE_REVIEWS_SUCCESS,
    SAVE_REVIEWS_SUCCESS,
    SAVE_REVIEWS_REQUEST,
    REVIEWS_APPROVED_REQUEST,
    REVIEWS_VERIFIED_REQUEST,
    SEND_REVIEWS_REQUEST_BULK,
    SEND_REVIEWS_REQUEST_BULK_SUCCESS,
    SEND_REVIEWS_REQUEST_BULK_ERROR,
    SEND_UPDATE_REVIEWS_REQUEST,
    SEND_UPDATE_REVIEWS_REQUEST_SUCCESS,
    QR_CREATION_REQUEST,
    QR_CREATION_REQUEST_SUCCESS,
    QR_CREATION_REQUEST_ERROR,
} from "../actions/reviewsActions";

const initialState = {
    loading: false,
    reviews: [],
    error: "",
    updateSuccess: false,
    sendRequestError: false,
    sendRequestSuccess: false,
    sendRequestMessage: "",
    sendUpdateRequestError: false,
    sendUpdateRequestSuccess: false,
    sendUpdateRequestMessage: "",
    qrCreationError: false,
    qrCreationSuccess: false,
    qrCreationMessage: "",
};

const reviewsReducer = (state = initialState, action) => {
    switch (action.type) {
    case FETCH_REVIEWS_REQUEST:
        return { ...state, loading: true, updating: false, sendUpdateRequestSuccess: false };
    case FETCH_REVIEWS_SUCCESS:
        return {
            ...state,
            loading: false,
            updating: false,
            reviews: action.payload,
            error: "",
        };
    case FETCH_REVIEWS_FAILURE:
        return {
            ...state,
            loading: false,
            updating: false,
            reviews: [],
            error: action.payload,
        };
    case UPDATE_REVIEWS_REQUEST:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: true,
        };
    case UPDATE_REVIEWS_SUCCESS:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: false,
            updateSuccess: true,
        };
    case REVIEWS_EXPORT_REQUEST:
        return { ...state, loading: false };
    case DELETE_ALL_REVIEW_REQUEST:
        return { ...state, loading: false };
    case DELETE_REVIEW_BY_PRODUCT_REQUEST:
        return {
            ...state,
            ...action.payload,
            loading: false,
        };
    case SAVE_REVIEWS_REQUEST:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: true,
        };
    case SAVE_REVIEWS_SUCCESS:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: false,
            updateSuccess: true,
        };
    case REVIEWS_APPROVED_REQUEST:
        return { ...state, loading: false };
    case REVIEWS_VERIFIED_REQUEST:
        return { ...state, loading: false };
    case SEND_REVIEWS_REQUEST_BULK:
        return {
            ...state,
            sendRequestError: false,
            sendRequestSuccess: false,
            loading: true,
        };
    case SEND_REVIEWS_REQUEST_BULK_SUCCESS:
        return {
            ...state,
            sendRequestSuccess: true,
            loading: false,
            sendRequestMessage: action.payload?.message,
        };
    case SEND_REVIEWS_REQUEST_BULK_ERROR:
        return {
            ...state,
            sendRequestError: true,
            sendRequestSuccess: false,
            loading: false,
            sendRequestMessage: action.payload?.message,
        };
    case SEND_UPDATE_REVIEWS_REQUEST:
        return {
            ...state,
            sendUpdateRequestError: false,
            sendUpdateRequestSuccess: false,
            loading: true,
        };
    case SEND_UPDATE_REVIEWS_REQUEST_SUCCESS:
        return {
            ...state,
            sendUpdateRequestError: false,
            sendUpdateRequestSuccess: true,
            sendUpdateRequestMessage: action.payload?.message,
            loading: false,
        };
    case QR_CREATION_REQUEST:
        return {
            ...state,
            qrCreationError: false,
            qrCreationSuccess: false,
            loading: true,
            qrCreationMessage: ""
        };
    case QR_CREATION_REQUEST_SUCCESS:
        return {
            ...state,
            qrCreationSuccess: true,
            loading: false,
            qrCreationMessage: action.payload,
        };
    case QR_CREATION_REQUEST_ERROR:
        return {
            ...state,
            qrCreationError: true,
            qrCreationSuccess: false,
            loading: false,
            qrCreationMessage: action.payload?.message,
        };
    default:
        return state;
    }
};

export default reviewsReducer;
